import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { ForYouSection } from '../components/ForYouSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ResultsSection } from '../components/ResultsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { StickyCTA } from '../components/StickyCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#FAF7F2] font-['DM_Sans'] text-[#2D2A26] selection:bg-[#4A6741] selection:text-white" data-id="element-170">
      <HeroSection data-id="element-171" />
      <ProblemSection data-id="element-172" />
      <SolutionSection data-id="element-173" />
      <MechanismSection data-id="element-174" />
      <DeliverablesSection data-id="element-175" />
      <ForYouSection data-id="element-176" />
      <HowItWorksSection data-id="element-177" />
      <ResultsSection data-id="element-178" />
      <FAQSection data-id="element-179" />
      <CTASection data-id="element-180" />
      <StickyCTA data-id="element-181" />

      <Footer data-id="element-182" />
    </main>;
}